// utils/confirmAction.js
import { Modal } from 'antd';

export const confirmAction = ({
    title = 'Are you sure?',
    content = 'This action cannot be undone.',
    okText = 'Yes',
    cancelText = 'No',
    onOk,
}) => {
    Modal.confirm({
        title,
        content,
        okText,
        cancelText,
        onOk,
        okButtonProps: { danger: true }, // Optional: make confirm red
    });
};
